import { AppIcon } from '../components.jsx';

export default function AppCard({ app, editMode, dragHandleProps, onEdit, onToggleHidden, style, cardRef }) {
  const content = (
    <div className="flex items-center gap-3 p-3">
      <AppIcon app={app} size={36} />
      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold">{app.name}</div>
        {app.description && <div className="truncate text-xs text-steel">{app.description}</div>}
      </div>
    </div>
  );

  return (
    <div
      ref={cardRef}
      style={style}
      className={`card relative overflow-hidden transition ${app.hidden ? 'opacity-50' : ''} ${
        editMode ? '' : 'hover:shadow-md'
      }`}
    >
      {editMode ? (
        <div className="flex items-center">
          <div {...dragHandleProps} className="cursor-grab touch-none px-2 py-3 text-steel/60 active:cursor-grabbing" title="Drag to reorder">
            ⠿
          </div>
          <div className="min-w-0 flex-1">{content}</div>
          <div className="flex shrink-0 items-center gap-1 pr-2">
            <button
              onClick={() => onEdit(app)}
              className="rounded-md p-1.5 text-steel hover:bg-steel/10"
              title="Edit"
            >
              ✎
            </button>
            <button
              onClick={() => onToggleHidden(app)}
              className="rounded-md p-1.5 text-steel hover:bg-steel/10"
              title={app.hidden ? 'Unhide' : 'Hide'}
            >
              {app.hidden ? '👁' : '🙈'}
            </button>
          </div>
        </div>
      ) : (
        <a href={app.launchUrl || '#'} target="_blank" rel="noreferrer" className="block">
          {content}
        </a>
      )}
    </div>
  );
}
